import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {ApiUrl} from '@emm/core/util/api-url.token';
import {standardRetry} from '@emm/core/util/rx.util';

@Injectable({
    providedIn: 'root'
})
export class TagService {

    constructor(@Inject(ApiUrl) private apiUrl: string, private http: HttpClient) {}



    getItemTags(tag: string): Observable<any> {
        return this.http.get(this.apiUrl + '/items/tag/' + tag).pipe(standardRetry());
    }



    getEmergencyTagAndItemTag(emergency: string, tag: string): Observable<any> {
        return this.http
            .get(`${this.apiUrl}/emergencies/mapping/${emergency}/${tag}`)
            .pipe(standardRetry());
    }



    getConsumerTags(tag: string): Observable<boolean> {
        return this.http.get<{ response: boolean }>(this.apiUrl + '/consumers/tag/' + tag).pipe(
            map((response) => response.response),
            standardRetry()
        );
    }



    getConsumerTypeTags(tag: string): Observable<boolean> {
        return this.http.get<{ response: boolean }>(this.apiUrl + '/destination-types/tag/' + tag).pipe(
            map((response) => response.response),
            standardRetry()
        );
    }



    getItemTypeTags(tag: string): Observable<boolean> {
        return this.http.get<{ response: boolean }>(this.apiUrl + '/item-types/tag/' + tag).pipe(
            map((response) => response.response),
            standardRetry()
        );
    }



    getLocationSetTypeTags(tag: string): Observable<boolean> {
        return this.http
            .get<{ response: boolean }>(this.apiUrl + '/location-set-types/tag/' + tag)
            .pipe(
                map((response) => response.response),
                standardRetry()
            );
    }



    getAttributeTags(tag: string): Observable<boolean> {
        return this.http.get<{ response: boolean }>(this.apiUrl + '/attributes/tags/' + tag).pipe(
            map((response) => response.response),
            standardRetry()
        );
    }



    getLocationStatusTags(tag: string): Observable<boolean> {
        return this.http.get<{ response: boolean }>(`${this.apiUrl}/location-status/tag/${tag}`).pipe(
            map((response) => response.response),
            standardRetry()
        );
    }



    getLocationSetTags(tag): Observable<boolean> {
        return this.http.get<{ response: boolean }>(`${this.apiUrl}/locationsets/tag/${tag}`).pipe(
            map((response) => response.response),
            standardRetry()
        );
    }



}
